import { Link } from '@hotjar/hotsauce';
import { useHelpHotjarUrl } from '@hotjar/translations';
import type { AbstractSingleFilterPillsProps } from '../SingleFilterType';
import { GenericShortListFilter } from '../GenericBloc/GenericShortListFilter/GenericShortListFilter';
import { FilterKindEnum } from '../../../../domains/global-filters/model/FilterChain';
import { getFilterMetadata } from '../../FilterChainUtils';
import { FEEDBACK_FILTER_OPTIONS } from './FeedbackFilterType';
import type { FEEDBACK_TYPE } from './FeedbackFilterType';

export function FeedbackFilter({
  currentValue,
  autoFocus,
  onApply,
  onRemove,
  onDropdownHidden,
  showDropdownOnMount,
}: AbstractSingleFilterPillsProps<FEEDBACK_TYPE[]>): JSX.Element {
  const helpHotjarUrl = useHelpHotjarUrl();
  const metadata = getFilterMetadata(FilterKindEnum.IncomingFeedback);
  return (
    <GenericShortListFilter
      autoFocus={autoFocus}
      filterName={metadata.filterName}
      iconName={metadata.iconName}
      currentValue={currentValue}
      onApply={onApply}
      onRemove={onRemove}
      optionList={FEEDBACK_FILTER_OPTIONS}
      onDropdownHidden={onDropdownHidden}
      showDropdownOnMount={showDropdownOnMount}
      header={
        <span>
          Sessions with users who submitted a response via{' '}
          <Link
            kind="inline"
            href={`${helpHotjarUrl}/articles/115011609267-What-is-Incoming-Feedback-`}
            isExternal
          >
            Feedback
          </Link>
        </span>
      }
    />
  );
}
